import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Markets } from './components/Markets';
import { Platform } from './components/Platform';
import { Psychology } from './components/Psychology';
import { Benefits } from './components/Benefits';
import { Steps } from './components/Steps';
import { Fomo } from './components/Fomo';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { track } from './utils/tracking';
const META = {
  title: 'Elyon Markets | Explora Nuevas Oportunidades de Trading',
  description: 'Descubre una experiencia moderna para explorar los mercados financieros y conoce la plataforma de Elyon Markets.',
  keywords: 'trading, forex, mercados financieros, plataforma de trading, Elyon Markets'
};
function useSeoAndTracking(): void {
  React.useEffect(() => {
    document.title = META.title;
    document.documentElement.lang = 'es';
    const setMeta = (key: 'name' | 'property', value: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${key}="${value}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(key, value);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', META.description);
    setMeta('name', 'keywords', META.keywords);
    setMeta('name', 'robots', 'index, follow');
    setMeta('property', 'og:title', META.title);
    setMeta('property', 'og:description', META.description);
    setMeta('property', 'og:type', 'website');
    track('page_view', {
      page: 'landing_elyon_markets'
    });
    track('view_content', {
      content_name: 'landing_elyon_markets'
    });
  }, []);
}
export function App() {
  useSeoAndTracking();
  return <div className="min-h-full w-full bg-white text-ink-900" data-id="element-0" data-mp="35ypel6klo1z">
      <a href="#mercados" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-xl focus:bg-brand-600 focus:px-4 focus:py-2 focus:text-[13px] focus:font-semibold focus:text-white" data-id="element-1" data-mp="38kw6ilmzzj5">
        Saltar al contenido
      </a>

      <Header data-id="element-2" data-mp="83i39jzcvyte" />

      <main data-id="element-3" data-mp="83qdt580as1f">
        <Hero data-id="element-4" data-mp="3gl4sdjnv24l3" />
        <TrustBar data-id="element-5" data-mp="3gkl9o0qdzc60" />
        <Markets data-id="element-6" data-mp="3gm64zskiyz4x" />
        <Platform data-id="element-7" data-mp="3glnzs6fvxakv" />
        <Psychology data-id="element-8" data-mp="3gj1ru5p30t24" />
        <Benefits data-id="element-9" data-mp="3bmjsjlcitmx6" />
        <Steps data-id="element-10" data-mp="3bn30c98giuxh" />
        <Fomo data-id="element-11" data-mp="3bnmfji6q357t" />
        <FAQ data-id="element-12" data-mp="3bo4lx7n3mztg" />
        <FinalCTA data-id="element-13" data-mp="3bk72ekwm0691" />
      </main>

      <Footer data-id="element-14" data-mp="3qbpnuy88mszs" />
      <StickyMobileCTA data-id="element-15" data-mp="3qbfztg6r6vwq" />
    </div>;
}